module.exports = __webpack_public_path__ + "assets/3a828aacee46b57987ffda7d1116feca.svg";